import { useState } from 'react';

export const useToggle = (initialState = false) => {
    const [isToggle, setIsToggle] = useState(initialState);

    const setToggle = toggle => setIsToggle(toggle);

    return [isToggle, setToggle];
};